import { render, staticRenderFns } from "./InsertIcon.vue?vue&type=template&id=52418022&"
import script from "./InsertIcon.vue?vue&type=script&lang=js&"
export * from "./InsertIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports